import { makeActionCreator } from '../../../config/store/utils';
import { readParquet } from '../../../services/productivityService';
import { sendCommentMaintenance } from '../../../services/maintenanceService';
import { batch } from 'react-redux';

// Action Types
export const GET_SCHEDULED_VOLVO = 'GET_SCHEDULED_VOLVO';
export const GET_SCHEDULED_VOLVO_ERROR = 'GET_SCHEDULED_VOLVO_ERROR';
export const GET_SCHEDULED_VOLVO_SUCCESS = 'GET_SCHEDULED_VOLVO_SUCCESS';

// Action Creators
export const onGetScheduledVolvo = makeActionCreator(GET_SCHEDULED_VOLVO);
export const onGetScheduledVolvoError = makeActionCreator(
  GET_SCHEDULED_VOLVO_ERROR,
  'payload'
);
export const onGetScheduledVolvoSuccess = makeActionCreator(
  GET_SCHEDULED_VOLVO_SUCCESS,
  'payload'
);

// Async action to fetch the Parquet data
export const onGetScheduledVolvoThunk = () => async dispatch => {
  dispatch(onGetScheduledVolvo()); // Start loading
  try {
    const patentHide = [
      'CAMI-R24',
      'CAAL-J46',
      'CATV-K79',
      'EXCA-541',
      'CATV-K29',
      'ROCO-002',
      'CATV-Z92',
      'CAPL-F17',
      'CATV-H91',
      'CATV-H93',
      'CATV-F31',
      'CAAL-Z47',
      'CAAL-V92',
      'BUS-X89',
      'CATV-Z90',
      'CAMI-Z25',
      'CATV-Z84',
      'CATV-F29',
      'CATV-W14',
      'CAMI-R97',
      'TRAO-517',
      'ROCO-158',
      'CAPL-T92',
      'RETRO-379',
      'MOTO-557',
      'RETRO-628',
      'CAMI-K46',
      'MIBU-L19',
      'CAEM-098',
      'CAAL-H89',
      'CATV-T44',
      'CAAL-W15',
      'MIBU-C18',
      'CATV-F93',
      'CATV-T45',
      'MOTO-554',
      'CAMI-D84',
      'CAMI-G75',
      'BUS-X91',
      'CAPL-W68',
      'CATV-H92',
      'CATV-F28',
    ];
    const type = 'last_maintenance_horometer_diff'; // Adjust the type if necessary
    const response = await readParquet({ type });
    const data = JSON.parse(response.data)
      .filter(item => !patentHide.includes(item.patente)) // Exclude hidden patents
      .map((item, index) => {
        return {
          ...item,
          id: `${index}`,
          horometer_diff_number: item.horometer_diff ?? 'Revisar Syrus',
          comment: item.comment ?? '...',
        };
      });
    dispatch(onGetScheduledVolvoSuccess({ data })); // Dispatch success with the data
  } catch (error) {
    dispatch(
      onGetScheduledVolvoError({
        error: error.message || 'Error fetching data',
      })
    ); // Dispatch error
  }
};

// Action Types
export const SEND_COMMENT_SCHEDULED = 'SEND_COMMENT_SCHEDULED';
export const SEND_COMMENT_SCHEDULED_ERROR = 'SEND_COMMENT_SCHEDULED_ERROR';
export const SEND_COMMENT_SCHEDULED_SUCCESS = 'SEND_COMMENT_SCHEDULED_SUCCESS';

// Action Creators
export const onSentScheduled = makeActionCreator(SEND_COMMENT_SCHEDULED);
export const onSentScheduledError = makeActionCreator(
  SEND_COMMENT_SCHEDULED_ERROR,
  'payload'
);
export const onSentScheduledSuccess = makeActionCreator(
  SEND_COMMENT_SCHEDULED_SUCCESS,
  'payload'
);

// Async action to fetch the Parquet data
export const onSentScheduledThunk = params => async dispatch => {
  dispatch(onSentScheduled()); // Start loading
  try {
    const response = await sendCommentMaintenance({ params });
    console.log(response);
    return batch(() => {
      dispatch(onSentScheduledSuccess());
    });
  } catch (error) {
    dispatch(
      onSentScheduledError({
        error: error.message || 'Error fetching data',
      })
    ); // Dispatch error
  }
};
